<template>
  <div>
    <v-card class="pa-4">
      <v-layout wrap class="form-control">
        <v-flex xs6 class="pt-1" row>
          <div class="primary--text">{{ $t('advanced search') }}</div>
        </v-flex>
        <v-flex xs6 class="text-xs-right">
          <v-btn flat icon @click="$emit('close')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12>
          <div>ประเภทช่าง :</div>
          <v-radio-group v-model="filter.user_type" row>
            <v-radio label="ทั้งหมด" value="" color="primary"></v-radio>
            <v-radio label="บุคคลภายนอก" value="guest" color="primary"></v-radio>
            <v-radio label="พนักงาน" value="staff" color="primary"></v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex xs6 class="pr-1">
          <div class="pb-1">ชื่อหน่วยงาน :</div>
          <input v-model="filter.unit_name" type="text" />
        </v-flex>
        <v-flex xs6 class="pl-1">
          <div class="pb-1">รหัสพนักงาน :</div>
          <input v-model="filter.staff_id" type="text" />
        </v-flex>
        <v-flex xs6 class="pr-1">
          <div class="pb-1">ชื่อ-นามสกุล :</div>
          <input v-model="filter.full_name" type="text" />
        </v-flex>
        <v-flex xs6 class="pl-1">
          <div class="pb-1">เบอร์โทรศัพท์ :</div>
          <input v-model="filter.phone_number" type="text" />
        </v-flex>
        <v-flex xs6 class="pr-1">
          <div class="pb-1">เลขบัตรประจำตัวประชาชน :</div>
          <input v-model="filter.id_card" type="text" />
        </v-flex>
        <v-flex xs12 class="pt-3">
          <div class="text-xs-center">
            <v-btn color="grey" outline @click="clearSearch">{{ $t('Clear Search') }}</v-btn>
            <v-btn color="primary" @click="onSearch">{{ $t('Search') }}</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

const initialFilter = {
  user_type: '',
  unit_name: '',
  staff_id: '',
  full_name: '',
  phone_number: '',
  id_card: ''
}
export default {
  components: {
    Multiselect
  },
  data() {
    return {
      filter: { ...initialFilter },
      unitTypeOptions: [
        {
          label: 'บุคคลภายนอก',
          value: 'guest'
        },
        {
          label: 'พนักงาน',
          value: 'staff'
        }
      ]
    }
  },
  methods: {
    clearSearch() {
      this.filter = { ...initialFilter }
      this.$emit('onSearch', this.filter)
    },
    onSearch() {
      this.$emit('onSearch', this.filter)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/YasaleAc/SearchEngineerDialog.vue